<template>
  <div class="row roomy align-center align-stretch">
    <div
      v-for="(sku, index) in filteredSkus"
      :key="sku"
      class="column-12 laptop:column-4"
    >
      <plan-summary-card
        v-if="!isLoading"
        :current-subscription="currentSubscription"
        :is-last="filteredSkus.length === index + 1"
        :modal-context-slug="upsellTriggerSlug"
        :plan="getPlan(sku)"
        :plan-color="planColor(sku)"
        is-in-modal-context
        :plan-icon-style="getPlanIconStyle(sku)"
        :subscription-discounts="subscriptionDiscounts"
        :on-sale="onSale(sku)"
      />
    </div>
  </div>
</template>

<script>
  import { get } from 'lodash'
  import { mapActions, mapGetters } from 'vuex'
  import { PLAN_COLOR_BY_SKU, PLANS_ON_SALE_BY_SKU, getAutoAppliedDiscounts, getKickstarterDiscounts } from 'app/views/plans/PlansData'
  import PlanSummaryCard from 'app/views/plans/components/PlanSummaryCard'

  export default {
    name: 'UpsellOptions',

    components: {
      PlanSummaryCard
    },

    props: {
      icon: {
        type: Object
      },
      isCustomIcon: {
        type: Boolean,
        default: false
      },
      upsellTriggerSlug: {
        type: String,
        required: true
      },
      upsellTrigger: {
        type: String,
        default: null
      }
    },

    data() {
      return {
        isLoading: true
      }
    },

    computed: {
      ...mapGetters('plans', ['skusForFilteredPlans', 'getPlan', 'subscriptionDiscounts']),
      ...mapGetters('subscriptions', ['currentSubscription']),

      userAction() {
        if (this.upsellTrigger.toLowerCase().includes('downloading')) return 'proDownloadEnabled'
        if (this.upsellTrigger.toLowerCase().includes('install')) return 'privateRegistriesEnabled'

        return 'active'
      },

      userHasAccessToPlanAction() {
        return this.$subscription.plan[this.userAction]
      },

      filteredSkus() {
        return this.skusForFilteredPlans({
          icon: this.icon,
          userAction: this.userAction,
          subscription: this.$subscription,
          isCustomIcon: this.isCustomIcon
        })
      },

      isBackerWithoutSubscription() {
        if (!this.$account) {
          return false
        }

        return this.$account.isBacker && !this.$subscription
      },
    },

    async created() {
      await this.fetchPlans()

      if (this.globalDiscountCode) {
        await this.fetchDiscounts([this.globalDiscountCode])
      } else if (getKickstarterDiscounts().length > 0 && this.isBackerWithoutSubscription) {
        await this.fetchDiscounts(getKickstarterDiscounts())
      } else if (getAutoAppliedDiscounts().length > 0) {
        await this.fetchDiscounts(getAutoAppliedDiscounts())
      }

      this.isLoading = false
    },

    methods: {
      ...mapActions('plans', ['fetchPlans', 'fetchDiscounts']),

      getPlanIconStyle(sku) {
        return sku.toLowerCase().includes('-plus') ? 'custom' : 'solid'
      },

      planColor(sku) {
        return get(PLAN_COLOR_BY_SKU, [sku], 'teal')
      },

      onSale(sku) {
        return PLANS_ON_SALE_BY_SKU.includes(sku)
      }
    }
  }
</script>
